import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { useMe } from "@/lib/hooks/use-me";

export function useMyShifts() {
  const { me } = useMe();
  const ITEMS_PER_PAGE = 10;

  const { data, fetchNextPage, hasNextPage, refetch } = useInfiniteQuery({
    queryKey: ["shifts", me?.employee?.id, ITEMS_PER_PAGE],
    queryFn: async (args) => {
      const res = await api.shift.getAll({
        pagination: {
          take: ITEMS_PER_PAGE,
          page: args.pageParam + 1,
        },
        sort: {
          field: "startAt",
          order: "asc",
        },
        filter: {
          // TODO: NEED TO FIX BACKEND. NOT REALLY SECURE IF EMPLOYEES CAN SEE OTHER EMPLOYEES SHIFTS
          employeeId: {
            value: me?.employee?.id,
            operator: "equals",
          },
          startAt: {
            value: new Date().toISOString(),
            operator: "gte",
          },
        },
        include: {
          project: {
            select: true,
          },
          position: {
            select: true,
          },
          userFunction: {
            select: true,
          },
        },
      });
      return res.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      const totalItems = lastPage.totalAmount;
      const currentItems = (lastPageParam + 1) * ITEMS_PER_PAGE;

      if (currentItems >= totalItems) {
        return undefined;
      }

      return lastPageParam + 1;
    },
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
      return firstPageParam - 1;
    },
    enabled: !!me?.employee?.id,
  });

  const loadMore = async (ev: CustomEvent) => {
    await fetchNextPage();
    if (ev.target) {
      (ev.target as any).complete();
    }
  };

  const shifts =
    data?.pages.flatMap((page) => page.items).filter((shift) => shift !== undefined) ?? [];

  return {
    shifts,
    loadMore,
    hasNextPage,
    refetch,
  };
}
